/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-13 11:08:34
 */
import Mock from 'mockjs'
// import { param2Obj } from '@/utils'
const waitDoing = Mock.mock({
  'data|1-3': [
    {
      'id|+1': 1,
      title: '@ctitle',
      'step|1-4': ['添加报名时间'],
      'series|1-6': [
        {
          'type|+1': ['encroll', 'enrollReview', 'uploadMaterials', 'gradeMaterials', 'materialsReview', 'onsideCompetition', 'playerCompetition', 'playerSpaceTime'],
          date: {
            start: '@date("yyyy-MM-dd")',
            end: '@date("yyyy-MM-dd")'
          }
        }
      ],
      task: [
        {
          title: '活动设置',
          'count|0-100': 10
        },
        {
          title: '报名',
          'count|0-100': 20
        },
        {
          title: '比赛',
          'count|0-100': 30
        },
        {
          title: '结果上报',
          'count|0-100': 40
        }
      ]
    }
  ]
})
const waitGetting = Mock.mock({
  status: 'success',
  'data|1-4': [
    {
      'id|+1': 1,
      title: '@ctitle',
      date: '@date("yyyy-MM-dd")'
    }
  ]
})

export default [
  {
    path: '/api/waitList',
    type: 'get',
    response: config => {
      return {
        status: 'success',
        data: waitDoing.data
      }
    }
  },
  {
    path: '/api/waitgetting',
    type: 'get',
    response: config => {
      return waitGetting
    }
  }
]



// WEBPACK FOOTER //
// ./src/mocks/modules/workbench.js